import React, { useEffect } from "react";
import {
  IdVerificationPaymentPollingContainerIdentityVerificationCaseV1Document,
} from "../../../../generated";
import { useLazyQuery } from "@apollo/client";
import { message, Skeleton, Typography } from "antd";

interface PaymentPollingContainerProps {
  caseId: string;
  applicantUserId: string;
  isPolling: boolean;
  setIsPolling: (isPolling: boolean) => void;
}

export const PaymentPollingContainer: React.FC<PaymentPollingContainerProps> = (
  props
) => {
  const [, { data: pollingData, startPolling, stopPolling }] = useLazyQuery(
    IdVerificationPaymentPollingContainerIdentityVerificationCaseV1Document,
    {
      variables: { identityVerificationCaseV1Id: props.caseId },
    }
  );

  useEffect(() => {
    if (props.isPolling) {
      startPolling(5000);
    }
  }, [props.isPolling]);

  useEffect(() => {
    if (
      pollingData?.identityVerificationCaseV1?.financeDetails?.transactions
        ?.submission?.transactionReference?.isSuccess === true
    ) {
      stopPolling();
      message.success("Payment successful");
      window.location.href = '/applicant/cases/'; // force reload to fix payment settings page not loading data
    } else if (
      pollingData?.identityVerificationCaseV1?.financeDetails?.transactions
        ?.submission?.transactionReference?.isSuccess === false
    ) {
      stopPolling();
      props.setIsPolling(false);
      message.error(
        "Payment failed: " +
          pollingData?.identityVerificationCaseV1?.financeDetails?.transactions
            ?.submission?.transactionReference?.errorMessage
      );
    }
  }, [pollingData]);

  return (
    <Skeleton.Node active style={{width: "100%", height: "100%"}}>
      <div style={{ border: "3px solid", borderRadius: "8px", padding: "8px 8px 0px 8px¯"}}>
      <Typography.Title level={3}>
        Your payment is currently being processed. Please do not reload the page...
      </Typography.Title>
      </div>
    </Skeleton.Node>
  );
};
